export const COUNT_ACTION = 'COUNT_ACTION'
export const COUNT_MESSAGES_ACTION = 'COUNT_MESSAGES_ACTION'
